import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/home/Home'
import Product from '@/pages/product/Product'
import Xls from '@/pages/product/Xls'
import Gt from '@/pages/product/Gt'
import Jmls from '@/pages/product/Jmls'
import Sjds from '@/pages/product/Sjds'
import Fl from '@/pages/product/Fl'
import Cysc from '@/pages/product/Cysc'
import Interface from '@/pages/interface/Interface'

import App from '@/pages/interface/components/App'
import Cx from '@/pages/interface/components/Cx'
import Fj from '@/pages/interface/components/Fj'
import Fz from '@/pages/interface/components/Fz'
import Gzh from '@/pages/interface/components/Gzh'
import Kj from '@/pages/interface/components/Kj'
import Pldf from '@/pages/interface/components/Pldf'
import Qb from '@/pages/interface/components/Qb'
import Sl from '@/pages/interface/components/Sl'
import Sm from '@/pages/interface/components/Sm'
import Tk from '@/pages/interface/components/Tk'
import Tm from '@/pages/interface/components/Tm'
import Tpsc from '@/pages/interface/components/Tpsc'
import Xcx from '@/pages/interface/components/Xcx'
import Ybtz from '@/pages/interface/components/Ybtz'
import Zshbj from '@/pages/interface/components/Zshbj'
import Zshktcp from '@/pages/interface/components/Zshktcp'
import Zysm from '@/pages/interface/components/Zysm'
import Tyxd from '@/pages/interface/components/Tyxd'
import Ycjdd from '@/pages/interface/components/Ycjdd'
import Zshcx from '@/pages/interface/components/Zshcx'
import Zshpz from '@/pages/interface/components/Zshpz'
import Zshfzxy from '@/pages/interface/components/Zshfzxy'
import Zshhd from '@/pages/interface/components/Zshhd'
import Shyecx from '@/pages/interface/components/shyecx'
import Xwzshbj from '@/pages/interface/components/xwzshbj'
import H5 from '@/pages/interface/components/h5'
import Kjbk from '@/pages/interface/components/kj/kjbk'
import Kjbkyz from '@/pages/interface/components/kj/kjbkyz'
import Kjxd from '@/pages/interface/components/kj/kjxd'
import Kjxdyz from '@/pages/interface/components/kj/kjxdyz'
import Kjjb from '@/pages/interface/components/kj/kjjb'
import Kjkys from '@/pages/interface/components/kj/kjkys'
import Kbin from '@/pages/interface/components/base/kbin'
import Bmdcx from '@/pages/interface/components/base/bmdcx'
import Tjbmd from '@/pages/interface/components/base/tjbmd'
import Introduce from '@/pages/introduce/Introduce'
import AcctAsynnotice from '@/pages/interface/components/acct/asynnotice'
import AcctCash from '@/pages/interface/components/acct/cash'
import AcctQuerybalance from '@/pages/interface/components/acct/querybalance'
import AcctQueryorder from '@/pages/interface/components/acct/queryorder'
import AcctSplitacct from '@/pages/interface/components/acct/splitacct'
import AcctTransfer from '@/pages/interface/components/acct/transfer'
import AcctUserbindcard from '@/pages/interface/components/acct/userbindcard'
import AcctUserreg from '@/pages/interface/components/acct/userreg'
import Yjkj from '@/pages/interface/components/kj/yjkj'
import Zshbbcx from '@/pages/interface/components/Zshbbcx'
import Ddzz from '@/pages/interface/components/kj/ddzz'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    }, {
      path: '/product',
      name: 'Product',
      component: Product
    }, {
      path: '/product/xls',
      name: 'Xls',
      component: Xls
    }, {
      path: '/product/gt',
      name: 'Gt',
      component: Gt
    }, {
      path: '/product/jmls',
      name: 'Jmls',
      component: Jmls
    }, {
      path: '/product/sjds',
      name: 'Sjds',
      component: Sjds
    }, {
      path: '/product/fl',
      name: 'Fl',
      component: Fl
    }, {
      path: '/product/cysc',
      name: 'Cysc',
      component: Cysc
    }, {
      path: '/interface',
      name: 'Interface',
      component: Interface,
      children: [{
        path: 'acct/asynnotice',
        components: {
          interfacePage: AcctAsynnotice
        }}, {
        path: 'acct/cash',
        components: {
          interfacePage: AcctCash
        }}, {
        path: 'acct/querybalance',
        components: {
          interfacePage: AcctQuerybalance
        }}, {
        path: 'acct/queryorder',
        components: {
          interfacePage: AcctQueryorder
        }}, {
        path: 'acct/splitacct',
        components: {
          interfacePage: AcctSplitacct
        }}, {
        path: 'acct/transfer',
        components: {
          interfacePage: AcctTransfer
        }}, {
        path: 'acct/userbindcard',
        components: {
          interfacePage: AcctUserbindcard
        }}, {
        path: 'acct/userreg',
        components: {
          interfacePage: AcctUserreg
        }}, {
        path: 'h5',
        components: {
          interfacePage: H5
        }}, {
        path: 'sm',
        components: {
          interfacePage: Sm
        }}, {
        path: 'gzh',
        components: {
          interfacePage: Gzh
        }}, {
        path: 'xcx',
        components: {
          interfacePage: Xcx
        }}, {
        path: 'tm',
        components: {
          interfacePage: Tm
        }}, {
        path: 'app',
        components: {
          interfacePage: App
        }}, {
        path: 'sl',
        components: {
          interfacePage: Sl
        }}, {
        path: 'fz',
        components: {
          interfacePage: Fz
        }}, {
        path: 'qb',
        components: {
          interfacePage: Qb
        }}, {
        path: 'zshbj',
        components: {
          interfacePage: Zshbj
        }}, {
        path: 'kj',
        components: {
          interfacePage: Kj
        }}, {
        path: 'kj/kjkys',
        components: {
          interfacePage: Kjkys
        }}, {
        path: 'kj/kjbk',
        components: {
          interfacePage: Kjbk
        }}, {
        path: 'kj/kjbkyz',
        components: {
          interfacePage: Kjbkyz
        }}, {
        path: 'kj/kjxd',
        components: {
          interfacePage: Kjxd
        }}, {
        path: 'kj/kjxdyz',
        components: {
          interfacePage: Kjxdyz
        }}, {
        path: 'kj/kjjb',
        components: {
          interfacePage: Kjjb
        }}, {
        path: 'fj',
        components: {
          interfacePage: Fj
        }}, {
        path: 'zysm',
        components: {
          interfacePage: Zysm
        }}, {
        path: 'cx',
        components: {
          interfacePage: Cx
        }}, {
        path: 'pldf',
        components: {
          interfacePage: Pldf
        }}, {
        path: 'tk',
        components: {
          interfacePage: Tk
        }}, {
        path: 'tpsc',
        components: {
          interfacePage: Tpsc
        }}, {
        path: 'ybtz',
        components: {
          interfacePage: Ybtz
        }}, {
        path: 'zshktcp',
        components: {
          interfacePage: Zshktcp
        }}, {
        path: 'tyxd',
        components: {
          interfacePage: Tyxd
        }}, {
        path: 'ycjdd',
        components: {
          interfacePage: Ycjdd
        }}, {
        path: 'zshhd',
        components: {
          interfacePage: Zshhd
        }}, {
        path: 'zshcx',
        components: {
          interfacePage: Zshcx
        }}, {
        path: 'zshfzxy',
        components: {
          interfacePage: Zshfzxy
        }}, {
        path: 'zshpz',
        components: {
          interfacePage: Zshpz
        }}, {
        path: 'base/kbin',
        components: {
          interfacePage: Kbin
        }}, {
        path: 'base/tjbmd',
        components: {
          interfacePage: Tjbmd
        }}, {
        path: 'base/bmdcx',
        components: {
          interfacePage: Bmdcx
        }}, {
        path: 'shyecx',
        components: {
          interfacePage: Shyecx
        }}, {
        path: 'xwzshbj',
        components: {
          interfacePage: Xwzshbj
        }}, {
        path: 'kj/yjkj',
        components: {
          interfacePage: Yjkj
        }}, {
        path: 'zshbbcx',
        components: {
          interfacePage: Zshbbcx
        }}, {
        path: 'kj/ddzz',
        components: {
          interfacePage: Ddzz
        }}
      ]
    }, {
      path: '/introduce',
      name: 'Introduce',
      component: Introduce
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js